import { Console } from 'console';
import {
  AmountsOwedReportsParamsForDownloading,
  IGetAmountsOwedReportsParams,
} from '../features/amountsOwedReports/amountsOwedReportsTypes';
import { apiClient } from './axiosInstance';
import { createDownloadLinkFromPdf } from './timeAndActivityReports';

export const fetchAmountsOwedReports = async (
  params: IGetAmountsOwedReportsParams
) => {
  const {
    isMyReports,
    startDate,
    endDate,
    sumDateRanges,
    detailedReports,
    noTimeOff,
    projectsIds,
    membersIds,
  } = params;
  const startDateQuery = startDate ? `startDate=${startDate}&` : '';
  const endDateQuery = endDate ? `endDate=${endDate}&` : '';

  const sumDateRangesQuery = sumDateRanges
    ? `sumDateRanges=${sumDateRanges}&`
    : '';

  const detailedReportsQuery = detailedReports
    ? `detailedReports=${detailedReports}&`
    : '';

  const noTimeOffQuery = noTimeOff
    ? `noTimeOff=${noTimeOff}&`
    : '';

  const projectsQuery =
    projectsIds && projectsIds.length > 0
      ? `projectsIds=${projectsIds.join('&projectsIds=')}&`
      : '';
  const membersQuery =
    membersIds && membersIds.length > 0
      ? `membersIds=${membersIds.join('&membersIds=')}&`
      : '';

  const queryStr = `?${startDateQuery}${endDateQuery}${sumDateRangesQuery}${detailedReportsQuery}${noTimeOffQuery}${projectsQuery}${membersQuery}`;

  if (isMyReports) {
    return await apiClient.get(`/reports/amounts-owed/my${queryStr}`);
  } else {
    return await apiClient.get(`/reports/amounts-owed${queryStr}`);
  }
};

export const downloadAmountsOwedReports = async (
  params: AmountsOwedReportsParamsForDownloading
) => {
  const {
    startDate,
    endDate,
    sumDateRanges,
    detailedReports,
    noTimeOff,
    projectsIds,
    membersIds,
    organizationName,
    reportType,
    isMyReports,
  } = params;
  const startDateQuery = startDate ? `startDate=${startDate}&` : '';
  const endDateQuery = endDate ? `endDate=${endDate}&` : '';

  const sumDateRangesQuery = sumDateRanges
    ? `sumDateRanges=${sumDateRanges}&`
    : '';

  const detailedReportsQuery = detailedReports
    ? `detailedReports=${detailedReports}&`
    : '';

  const noTimeOffQuery = noTimeOff
    ? `noTimeOff=${noTimeOff}&`
    : '';

  const projectsQuery =
    projectsIds && projectsIds.length > 0
      ? `projectsIds=${projectsIds.join('&projectsIds=')}&`
      : '';
  const membersQuery =
    membersIds && membersIds.length > 0
      ? `membersIds=${membersIds.join('&membersIds=')}&`
      : '';

  const queryStr = `?${startDateQuery}${endDateQuery}${sumDateRangesQuery}${detailedReportsQuery}${noTimeOffQuery}${projectsQuery}${membersQuery}`;

  await apiClient
    .get(`/reports/amounts-owed${isMyReports ? "/my" : ""}/pdf${queryStr}`, {
      headers: { 'Content-Type': 'application/pdf' },
      responseType: 'blob',
    })
    .then(
      createDownloadLinkFromPdf({
        startDate,
        endDate,
        reportType,
        organizationName,
        sumDateRanges: sumDateRanges === 'true',
        detailedReports: detailedReports === 'true',
        noTimeOff: noTimeOff === 'true'
      })
    )
    .catch((error: unknown) => {
      console.error('Error downloading file:', error);
    });
};
